<div class="remittance-document">
  <div class="header-section">
    <div class="remittance-header">Remittance (Copy)</div>
    <div class="company-name">{{remittanceDocument?.CompanyName}}</div>
  </div>
  <div class="body-section">
    <div class="address-section">
      <div class="header row">To:</div>
      <div class="row">{{remittanceDocument?.CreditorName}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress1}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress2}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress3}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress4}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress5}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress6}}</div>
      <div class="row">{{remittanceDocument?.BlockAddress7}}</div>

    </div>

    <div class="remittance-section">
      <div class="row">
        <div class="header">Remittance Date:</div>
        <div class="value">{{remittanceDocument?.RemittanceDate | date:'dd MMM yyyy' }}</div>
      </div>
      <div class="row">
        <div class="header">Creditor Ref:</div>
        <div class="value">{{remittanceDocument?.CreditorRef }}</div>
      </div>
      <div class="row">
        <div class="header">Remittance No:</div>
        <div class="value">{{remittanceDocument?.RemittanceNo }}</div>
      </div>
    </div>

    <div class="document-section">
      <table>
        <thead>
          <tr>
            <th>Document Ref</th>
            <th>Description</th>
            <th>Document Date</th>
            <th>Payment Details</th>
            <th style="text-align: right">Amount({{remittanceDocument?.CurrencySymbol}})</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of (remittanceDocument)?.DetailItems">
            <td>{{item.DocumentRef}}</td>
            <td>{{item.Description}}</td>
            <td>{{item.DocumentDate | date:'dd MMM yyyy'}}</td>
            <td>{{item.PaymentDetails}}</td>
            <td style="text-align: right">{{item.Amount | number : '1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td style="border-top: 1px solid;">Total({{remittanceDocument?.CurrencySymbol}})</td>
            <td style="text-align: right; border-top: 1px solid;">{{remittanceTotal | number : '1.2-2'}}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="payments-section">
      <table>
        <thead>
          <tr>
            <th>Payment Made To:</th>
            <th></th>
            <th>Paid By:</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Bank Account Name:</td>
            <td>{{remittanceDocument?.BankAccountName }}</td>
            <td>{{remittanceDocument?.PaidBy }}</td>
            <td></td>
          </tr>
          <tr>
            <td>Bank Sort Code:</td>
            <td>{{remittanceDocument?.BankSortCode }}</td>
            <td>{{paymentReferenceText(remittanceDocument?.PaidBy)}}</td>
            <td>{{remittanceDocument?.ChequeNumber }}</td>
          </tr>
          <tr>
            <td>Bank Account Number:</td>
            <td>{{remittanceDocument?.BankAccountNumber }}</td>
            <td>Roll Number:</td>
            <td>{{remittanceDocument?.RollNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
